import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material/RadioGroup';
import { ReactNode } from 'react';

import { Box } from './Box';
import { FormControlLabel } from './FormControlLabel';
import { FormLabel } from './FormLabel';
import { Radio } from './Radio';

import type { RadioProps } from './Radio';

export interface RadioGroupOption {
  label: ReactNode;
  value: boolean | number | string;
  sx?: RadioProps['sx'];
}

export interface RadioGroupProps extends MuiRadioGroupProps {
  options?: RadioGroupOption[];
  label?: ReactNode;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  children,
  label,
  options,
  sx,
  ...props
}) => (
  <FormLabel sx={sx}>
    {label && <Box sx={{ mb: 2 }}>{label}</Box>}
    <MuiRadioGroup sx={{ gap: 2 }} {...props}>
      {children ||
        options?.map((option) => (
          <FormControlLabel
            key={String(option.value)}
            value={option.value}
            label={option.label}
            sx={option.sx}
            control={<Radio />}
          />
        ))}
    </MuiRadioGroup>
  </FormLabel>
);
